import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { moment } from '../../utils/moment';
export const renderCalendarHeader = (param)=>{
    let { monthDate, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "react-datepicker__header-nav",
        children: [
            /*#__PURE__*/ _jsx(CalendarNavButton, {
                direction: "prev",
                onClick: decreaseMonth,
                disabled: prevMonthButtonDisabled
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "react-datepicker__current-month",
                children: moment(monthDate).format('MMMM')
            }),
            /*#__PURE__*/ _jsx(CalendarNavButton, {
                direction: "next",
                onClick: increaseMonth,
                disabled: nextMonthButtonDisabled
            })
        ]
    });
};
export const CalendarNavButton = (props)=>{
    const { direction, onClick, disabled } = props;
    const label = direction === 'prev' ? 'Vorige maand' : 'Volgende maand';
    return /*#__PURE__*/ _jsx("button", {
        type: "button",
        className: `react-datepicker__nav-button react-datepicker__nav-button--${direction} button button--secondary button--icon`,
        onClick: onClick,
        disabled: disabled,
        "aria-label": label,
        children: /*#__PURE__*/ _jsx("svg", {
            className: "button__icon",
            width: "20px",
            height: "20px",
            "aria-hidden": "true",
            children: /*#__PURE__*/ _jsx("use", {
                xlinkHref: "#icon--arrow-left"
            })
        })
    });
};
